

export default {
    data() {
        return {

        };
    },

    props: {
      src: {
        type: String,
        default: '',
      },
      href: {
        type: String,
        default: '',
      },
    },

    computed: {

    },

    watch: {

    },

    methods: {

    },

    components: {

    },

    created() {

    },
    mounted() {

    },
};




// WEBPACK FOOTER //
// ./scripts/vue/LazyBackgroundImage.vue